import { ToasterPositionEnum } from '@app/shared/enums-interfaces/_internal';

function error(message = "Something didn't quite go as planned. Please try again later.", title = 'Error') {
    return {
        key: ToasterPositionEnum.TOP_CENTER,
        severity: 'error',
        summary: title,
        detail: message,
        icon: 'pi-minus-circle',
    };
}

function warning(message: string, title = 'Warning') {
    return {
        key: ToasterPositionEnum.TOP_CENTER,
        severity: 'warn',
        summary: title,
        detail: message,
        icon: 'pi-exclamation-triangle',
    };
}

function success(message: string, title = 'Success') {
    return {
        key: ToasterPositionEnum.BOTTOM_RIGHT,
        severity: 'success',
        summary: title,
        detail: message,
        icon: 'pi-check-square',
    };
}

function info(message: string, title = 'Info') {
    return {
        key: ToasterPositionEnum.TOP_CENTER,
        severity: 'info',
        summary: title,
        detail: message,
        icon: 'pi-exclamation-circle',
    };
}

export const ToasterHelper = {
    error,
    warning,
    success,
    info,
};
